<template>
    <div class="subscribe-form">
        <div class="head d-block d-sm-flex justify-content-center align-items-center">
            <div class="d-flex justify-content-center mr-sm-3 mb-4 mb-md-0">
                <img class="subscribe-img"
                     width="92"
                     height="56"
                     :src="asset_cdn('assets/subscribe.svg')"
                     loading="lazy"
                     :alt="getTrans('subscribe.newsletterButtonText', 'Squeeze Me In')"
                     :title="getTrans('subscribe.newsletterButtonText', 'Squeeze Me In')">
            </div>
            <div class="text-center ml-3">
                <span class="h2 subscribe-title mb-2 d-block">
                    <Translate translationKey="subscribe.newsletterTitle"
                               fallback="Get Daily Crypto Insights That Finally Click" />
                </span>
                <p class="subscribe-subtitle mb-3">
                    <Translate translationKey="subscribe.newsletterSubtitle"
                               fallback="Join 120,000+ Daily Squeeze subscribers and get our 5 min newsletter with the juicy insights, and tips to spice up your investment game daily." />
                </p>
            </div>
        </div>
        <div class="content my-4">
            <div class="form-group text-left mr-md-3">
                <input v-model="email"
                       type="email"
                       :placeholder="getTrans('subscribe.inputPlaceholder', 'Enter email here')"
                       :class="{ 'error-wrapper--active': errorMessage }"
                       class="input form-control email"
                       name="email"
                       required>
                <div v-if="errorMessage"
                     class="error-message">
                    {{ errorMessage }}
                </div>
            </div>
            <div>
                <div id="subscribe-form-proceed-button" />
                <BaseButton class="g-recaptcha"
                            @click="loadRecaptchaAndProceed">
                    <Translate translationKey="subscribe.newsletterButtonText"
                               fallback="Squeeze Me In" />
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Translate from '@/js/helpers/Translate.vue';
    import { asset_cdn } from '../helpers/helpers';
    import { getTrans } from '../helpers/getTrans';
    import { subscriberSourceEnum } from '../enums/subscriberSourceEnum';
    import { useSubscribeForm } from './composables/useSubscribeForm';
    import BaseButton from '@/js/components/BaseButton.vue';

    const SUBSCRIBE_FORM_BUTTON_ID = 'subscribe-form-proceed-button';
    const {
        email,
        errorMessage,
        loadRecaptchaAndProceed,
    } = useSubscribeForm(subscriberSourceEnum.SOURCE_NEWSLETTER_FOOTER, [subscriberSourceEnum.SOURCE_NEWSLETTER, subscriberSourceEnum.SOURCE_NEWSLETTER_FOOTER], SUBSCRIBE_FORM_BUTTON_ID, true);
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/design-system/variables" as variables;
@use "@/sass/partials/breakpoints" as breakpoints;

.input {
    width: 100%;
    height: 50px;
    padding: 6px 12px;
    border-radius: 10px;
    background: variables.$baseWhite;
    font-size: 16px;
    outline: none;
    transition: 0.2s ease-in-out;

    &:focus {
        background: variables.$baseWhite;
    }

    &::placeholder {
        color: variables.$gray800;
    }
}

.subscribe-form {
    max-width: 690px;
    margin: auto;

    .subscribe-title {
        @media (min-width: breakpoints.$md-breakpoint) {
            white-space: nowrap;
        }
    }

    .subscribe-subtitle {
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
    }

    .subscribe-img {
        display: block;
        max-width: unset;
        padding: unset;
        border: unset;
        border-radius: 8px;
        margin: 0;
    }

    .error-wrapper--active {
        border: 1px solid variables.$error600;
    }

    .error-message {
        margin-top: 2px;
        color: variables.$error600;
        font-size: 12px;
        line-height: 19px;
    }
}

.subscribe-section {
    margin: 32px 0;
    background-color: variables.$baseWhite;

    .head {
        text-align: left;
    }

    .content {
        display: flex;

        .form-group {
            flex: 1;
        }
    }

    @media (max-width: breakpoints.$md-breakpoint) {
        .head {
            text-align: center;
        }

        .content {
            display: block;
            margin-bottom: 15px;
            text-align: center;
        }
    }
}

.subscribe-news-section {
    .subscribe-form {
        padding-top: 40px;
    }
}

.dark-theme {
    .subscribe-title {
        color: variables.$baseWhite;
        font-size: 32px;
        font-weight: 400;
        line-height: 40px;
    }

    .subscribe-subtitle {
        color: variables.$gray300;
    }

    .input {
        color: variables.$gray800;
    }
}
</style>
